<template>
    <SimpleForm api="conversion" title="Document Converter" id="document-converter" :fields="fields"/>
</template>

<script>

import SimpleForm from '../../../components/forms/SimpleForm.vue';

const formFields = [
    ['enabled', {component: 'otif-switch'}],
    ['enabledTikaConverter', {
        component: 'otif-select',
        values: [{
            value: 'true',
            label: 'Embedded Tika (recommended)'
        },{
            value: 'false',
            label: 'Conversion Service'
        }]
    }],
    'name',
    'conversionServiceClusterName',
    'conversionServiceMaxAttempts',
    'conversionServiceDelay',
    'conversionServiceConnectionTimeout'
];

export default {
    data() {
        return {
            fields: formFields
        }
    },

    components: {
        SimpleForm
    }
}

</script>
